module.exports = __webpack_public_path__ + "static/media/full_time_tutor_intro_english.03b5a3f1.jpg";